import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function TourOperatorInfantBookingFareDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Tour Operator Infant Booking Fare")}
      endpoint={`/fares/tour-operator-infant-fares/${props.match.params.id}/`}
      successRoute={reverse("tourOperatorInfantBookingFareList")}
      errorRoute={reverse("tourOperatorInfantBookingFareList")}
    />
  )
}

TourOperatorInfantBookingFareDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
